var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_vm._m(0),(_vm.type !== 'attachment')?_c('div',{staticClass:"jdt"},[_c('div',{staticClass:"jdt-main"},_vm._l((_vm.xmItem),function(item,index){return _c('div',{key:item.index,staticClass:"item",class:{
                'item-top_item0ea04d': item.status == 1 || item.status == 2
            }},[_c('div',{staticClass:"item-top",style:({
                    background: item.status == 0 ? '#DEE2E6' : item.status == 1 ? '#ABEDCB' : '#1070CB'
                })},[_vm._v(" "+_vm._s(index + 1)+" ")]),_c('span',{staticClass:"item-text"},[_vm._v(_vm._s(item.name))])])}),0)]):_vm._e(),_c('el-form',{attrs:{"model":_vm.vo},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"el-table el-table--fit el-table--border",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"el-table__body-wrapper"},[_c('table',{staticClass:"el-table__body",attrs:{"cellspacing":"0","cellpadding":"0","border":"0"}},[_c('tbody',[_c('tr',[_c('td',{ref:"tdlbl_项目名称",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('flSubject'),expression:"'flSubject'"}],staticClass:"field"},[_vm._v("项目名称")])]),_c('td',{staticClass:"el-table__cell tdcont tdw83",attrs:{"colspan":"5"}},[_c('form-item',{ref:"flSubject",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入项目名称',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '项目名称',
                                    propName: 'flSubject',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 1000,
                                    valueMinLength: null,
                                    model: 'vo.flSubject',
                                    option: [],
                                    autocomplete: 'off',
                                    dialog: 0,
                                    showWordLimit: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_项目编号",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbXmbh'),expression:"'tbXmbh'"}],staticClass:"field"},[_vm._v("项目编号")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"tbXmbh",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入项目编号',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '项目编号',
                                    propName: 'tbXmbh',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 100,
                                    valueMinLength: null,
                                    model: 'vo.tbXmbh',
                                    option: [],
                                    autocomplete: 'off',
                                    dialog: 0,
                                    showWordLimit: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1),_c('td',{ref:"tdlbl_项目类型",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbType'),expression:"'tbType'"}],staticClass:"field"},[_vm._v("项目类型")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"tbType",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: '1：招标代理\n2：造价咨询\n3：其它',
                                    elementType: 'select',
                                    emptyMessage: '请选择项目类型',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '项目类型',
                                    propName: 'tbType',
                                    propType: 'Short',
                                    textFormatter: null,
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.tbType',
                                    option: [
                                        { value: '1', name: '招标代理' },
                                        { value: '2', name: '造价咨询' },
                                        { value: '3', name: '其它' }
                                    ],
                                    optionGenerateType: 0,
                                    clearable: false,
                                    filterable: false,
                                    allowCreate: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_投标日期 ",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbDate'),expression:"'tbDate'"}],staticClass:"field"},[_vm._v("投标日期")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"tbDate",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                    elementType: 'date',
                                    emptyMessage: '请输入投标日期 ',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '投标日期 ',
                                    propName: 'tbDate',
                                    propType: 'java.util.Date',
                                    textFormatter: 'yyyy年MM月dd日\r\n',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.tbDate',
                                    option: [],
                                    weekday: 0
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1),_c('td',{ref:"tdlbl_项目负责人",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbXmFzr'),expression:"'tbXmFzr'"}],staticClass:"field"},[_vm._v("项目负责人")])]),_c('td',{staticClass:"el-table__cell tdcont tdw83",attrs:{"colspan":"5"}},[_c('form-item',{ref:"tbXmFzr",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入项目负责人',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '项目负责人',
                                    propName: 'tbXmFzr',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 1000,
                                    valueMinLength: null,
                                    model: 'vo.tbXmFzr',
                                    option: [],
                                    autocomplete: 'off',
                                    dialog: 0,
                                    showWordLimit: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_计划开始时间 ",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('startDate'),expression:"'startDate'"}],staticClass:"field"},[_vm._v("计划开始时间")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"startDate",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                    elementType: 'date',
                                    emptyMessage: '请输入计划开始时间 ',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '计划开始时间 ',
                                    propName: 'startDate',
                                    propType: 'java.util.Date',
                                    textFormatter: 'yyyy年MM月dd日\r\n',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.startDate',
                                    option: [],
                                    weekday: 0
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1),_c('td',{ref:"tdlbl_计划结束时间 ",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('endDate'),expression:"'endDate'"}],staticClass:"field"},[_vm._v("计划结束时间")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"endDate",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                    elementType: 'date',
                                    emptyMessage: '请输入计划结束时间 ',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '计划结束时间 ',
                                    propName: 'endDate',
                                    propType: 'java.util.Date',
                                    textFormatter: 'yyyy年MM月dd日\r\n',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.endDate',
                                    option: [],
                                    weekday: 0
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_负责人联系电话",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbXmFzrPhone'),expression:"'tbXmFzrPhone'"}],staticClass:"field"},[_vm._v("负责人联系电话")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"tbXmFzrPhone",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入负责人联系电话',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '负责人联系电话',
                                    propName: 'tbXmFzrPhone',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 50,
                                    valueMinLength: null,
                                    model: 'vo.tbXmFzrPhone',
                                    option: [],
                                    autocomplete: 'off',
                                    dialog: 0,
                                    showWordLimit: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1),_c('td',{ref:"tdlbl_负责人邮箱",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbXmFrzEmail'),expression:"'tbXmFrzEmail'"}],staticClass:"field"},[_vm._v("负责人邮箱")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"tbXmFrzEmail",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入负责人邮箱',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '负责人邮箱',
                                    propName: 'tbXmFrzEmail',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 50,
                                    valueMinLength: null,
                                    model: 'vo.tbXmFrzEmail',
                                    option: []
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_工期（人天）",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('workDay'),expression:"'workDay'"}],staticClass:"field"},[_vm._v("工期（人天）")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"workDay",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入工期（人天）',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '工期（人天）',
                                    propName: 'workDay',
                                    propType: 'Integer',
                                    textFormatter: 'integer',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.workDay',
                                    option: []
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1),_c('td',{ref:"tdlbl_项目预算金额（元）",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('tbAmount'),expression:"'tbAmount'"}],staticClass:"field"},[_vm._v("项目预算金额（元）")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"tbAmount",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入项目预算金额（元）',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '项目预算金额（元）',
                                    propName: 'tbAmount',
                                    propType: 'java.math.BigDecimal',
                                    textFormatter: 'textfield',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.tbAmount',
                                    option: [],
                                    autocomplete: 'off',
                                    dialog: 0,
                                    showWordLimit: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_项目简介",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('flContent'),expression:"'flContent'"}],staticClass:"field"},[_vm._v("项目简介")])]),_c('td',{staticClass:"el-table__cell tdcont tdw83",attrs:{"colspan":"5"}},[_c('form-item',{ref:"flContent",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: 70,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'textarea',
                                    emptyMessage: '请输入项目简介',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '项目简介',
                                    propName: 'flContent',
                                    propType: 'String',
                                    textFormatter: 'textarea',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'vo.flContent',
                                    option: []
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{staticClass:"tdlbl tdw100",staticStyle:{"text-align":"left !important","background":"#fff !important"},attrs:{"colspan":"6"}},[_c('div',[_vm._v("建设单位")])])]),_c('tr',[_c('td',{ref:"tdlbl_建设单位",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('projectUnit'),expression:"'projectUnit'"}],staticClass:"field"},[_vm._v("建设单位")])]),_c('td',{staticClass:"el-table__cell tdcont tdw83",attrs:{"colspan":"5"}},[_c('form-item',{ref:"projectUnit",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入建设单位',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '建设单位',
                                    propName: 'projectUnit',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 200,
                                    valueMinLength: null,
                                    model: 'vo.projectUnit',
                                    option: [],
                                    autocomplete: 'off',
                                    dialog: 0,
                                    showWordLimit: false
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_联系人",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('projectFzr'),expression:"'projectFzr'"}],staticClass:"field"},[_vm._v("联系人")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"projectFzr",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入联系人',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '联系人',
                                    propName: 'projectFzr',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 50,
                                    valueMinLength: null,
                                    model: 'vo.projectFzr',
                                    option: []
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1),_c('td',{ref:"tdlbl_联系电话",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('projectFzrPhone'),expression:"'projectFzrPhone'"}],staticClass:"field"},[_vm._v("联系电话")])]),_c('td',{staticClass:"el-table__cell tdcont tdw33",attrs:{"colspan":"2"}},[_c('form-item',{ref:"projectFzrPhone",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入联系电话',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '联系电话',
                                    propName: 'projectFzrPhone',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 50,
                                    valueMinLength: null,
                                    model: 'vo.projectFzrPhone',
                                    option: []
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)]),_c('tr',[_c('td',{ref:"tdlbl_联系地址",staticClass:"el-table__cell tdlbl tdw17",attrs:{"colspan":"1"}},[_c('span',{staticClass:"required"},[_vm._v("*")]),_c('span',{directives:[{name:"field-lbl",rawName:"v-field-lbl",value:('projectUnitAddress'),expression:"'projectUnitAddress'"}],staticClass:"field"},[_vm._v("联系地址")])]),_c('td',{staticClass:"el-table__cell tdcont tdw83",attrs:{"colspan":"5"}},[_c('form-item',{ref:"projectUnitAddress",attrs:{"field":{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementType: 'input',
                                    emptyMessage: '请输入联系地址',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '联系地址',
                                    propName: 'projectUnitAddress',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 200,
                                    valueMinLength: null,
                                    model: 'vo.projectUnitAddress',
                                    option: []
                                },"vo":_vm.vo,"can-edit":_vm.canEdit}})],1)])])])])])]),_c('el-button',{staticStyle:{"margin-top":"20px"},attrs:{"type":"primary"},on:{"click":_vm.handleEdit}},[_vm._v(_vm._s(_vm.handleEditTitle))])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"28px"}},[_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v("立项信息")])])
}]

export { render, staticRenderFns }